import axios from 'axios'

const apiClient = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Oc-Merchant-Id': process.env.VUE_APP_MERCHANT_ID
  },
  timeout: 60000
})

export default {
  async callMeBack(form) {
    return await apiClient.post('/console/index.php?route=rest/crm/callMeBack', {
        first_name: form.first_name,
        last_name: form.last_name,
        contact_number: form.contact_number,
    });
  }
}